var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-team"},[_c('WidgetPrimary',{attrs:{"title":"Équipe"}},[_c('div',{staticClass:"team"},[_c('TeamDay',{attrs:{"team":_vm.team}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }